import { render } from "./CentralizedTemplate.vue?vue&type=template&id=5a9ac658&scoped=true"
import script from "./CentralizedTemplate.vue?vue&type=script&lang=js"
export * from "./CentralizedTemplate.vue?vue&type=script&lang=js"

import "./CentralizedTemplate.vue?vue&type=style&index=0&id=5a9ac658&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a9ac658"]])

export default __exports__